import React from 'react';
import { Column } from '../components/Table/types';
import { NewToOldAmount } from '../components/NewToOldAmount';
import { EditPayrollListItem } from './types';
import { OvertimeColumnCell } from './OvertimeColumnCell';
import useFeature from 'hooks/useFeature';

export const useEditPayrollAmountColumns = (): Column<EditPayrollListItem>[] => {
  const isOvertimeEnabled = useFeature('overtime');

  const columns: Column<EditPayrollListItem>[] = [
    {
      title: 'Additions',
      render: (item) => {
        return (
          <NewToOldAmount newAmount={item.additions.newSum} oldAmount={item.additions.oldSum} />
        );
      },
      styles: {
        textAlign: 'right',
      },
    },
    {
      title: 'Deductions',
      render: (item) => {
        return (
          <NewToOldAmount newAmount={item.deductions.newSum} oldAmount={item.deductions.oldSum} />
        );
      },
      styles: {
        textAlign: 'right',
      },
    },
    {
      title: 'Arrears',
      render: (item) => {
        return <NewToOldAmount newAmount={item.arrears.new} oldAmount={item.arrears.old} />;
      },
      styles: {
        textAlign: 'right',
      },
    },
  ];

  if (isOvertimeEnabled) {
    columns.push({
      title: 'Overtime',
      render: (item) => {
        if (item.overtime.entries.length === 0) {
          return <>-</>;
        }
        return (
          <OvertimeColumnCell
            entries={item.overtime.entries}
            userId={item.forPeopleId}
            payrollMonth={item.overtimePayrollMonth}
          />
        );
      },
      styles: {
        textAlign: 'right',
      },
    });
  }

  return columns;
};
